import EmbedCodeGenerator from '../../utils/embed';

var module = angular.module('embed');

module.component('embedBroadcasts', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=', // Fix data flow
    singleEvent: '=?',
  },
  template: require('./embed-broadcasts.html'),
  controllerAs: 'vm',
  controller: EmbedDirectiveController,
});

module.component('embedHighlights', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=', // Fix data flow
    singleEvent: '=?',
  },
  template: require('./embed-highlights.html'),
  controllerAs: 'vm',
  controller: EmbedDirectiveController,
});

module.component('embedOther', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=', // Fix data flow
    singleEvent: '=?',
  },
  template: require('./embed-other.html'),
  controllerAs: 'vm',
  controller: EmbedDirectiveController,
});

module.component('embedSelectBroadcasts', {
  bindings: {
    parentVM: '=parentVm',
    mode: '@',
    hideAll: '=',
    hideChannels: '=',
    hideSources: '=',
    hideSingleBroadcast: '=',
    broadcastValidator: '=',
  },
  controllerAs: 'vm',
  controller: function () {
    this.$onInit = () => {
      if (this.mode == 'highlights') {
        this.label = 'Highlights';
      } else {
        this.label = 'Broadcasts';
      }
    };

    // Fake the EditOrCreateEventService for purposes on the <recording-source-chooser />
    this.service = {
      sourceBroadcast: null,
      sourceBroadcastUnavailable: null,
      broadcast: {},
      updateSourceBroadcast: (b) => (this.service.sourceBroadcast = b),
    };
  },
  template: require('./embed-select-broadcasts.html'),
});

module.component('embedCopyPaste', {
  bindings: {
    parentVM: '=parentVm',
    type: '@',
  },
  controllerAs: 'vm',
  template: require('./embed-copy-paste.html'),
});

module.component('embedAdvancedSettings', {
  bindings: {
    parentVM: '=parentVm',
  },
  controllerAs: 'vm',
  template: require('./embed-advanced-settings.html'),
});

function EmbedDirectiveController(
  $uibModal,
  $scope,
  $rootScope,
  Account,
  BoxCaster,
  StaticRTMP,
  Broadcast,
  Channel,
  clipboard
) {
  'ngInject';

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.showHighlights = !!this.FeatureFlags.highlights;
  this.m3u8Enabled =
    !$rootScope.account.extra_features.static_m3u8_disabled &&
    $rootScope.user.can('embed', 'broadcast/*:m3u8');
  this.BoxCaster = BoxCaster;
  this.StaticRTMP = StaticRTMP;
  this.Broadcast = Broadcast;
  this.Channel = Channel;

  this.$onInit = () => {
    this.changeLayout(this.output.layout);
  };

  // Set embed defaults based on account content settings
  const a = $rootScope.account;
  const cs = a.content_settings;
  if (cs.showDonations) this.output.args.showDonations = true;
  if (cs.showCountdown) this.output.args.showCountdown = true;
  if (cs.poster) {
    this.showPoster = true;
    this.output.args.poster = cs.poster;
  }
  if (cs.customPreroll) {
    this.showPreroll = true;
    this.output.args.customPreroll = cs.customPreroll;
  }

  this.showAutoplayOptions = !!this.output.args.autoplay;

  $scope.clipboard = clipboard; //isolate scope here to didn't inherit this from $rootScope
  $scope.$watch(
    () => this.output.args.market,
    (market) => (this.showVersionOverride = market == 'internal')
  );

  this.showPreroll = false;
  this.showPoster = false;

  this.showPodcastOption = (which) => {
    if (!this.FeatureFlags.podcast) return false;
    if (this.output.type != 'channel') return false;
    if (!this.output.channel) return false;
    if (this.output.channel.id !== this.output.channelId) return false;
    return true;
  };

  this.allowPodcastForChannel = (which) => {
    if (!this.showPodcastOption(which)) return false;
    const ccs = this.output.channel.content_settings || {};
    if (!ccs.podcast) return false;
    if (!which) return true;
    return ccs.podcast[which];
  };

  var ngResources = {};

  this.clearPrerollIfNecessary = () => {
    if (!this.showPreroll) delete this.output.args.customPreroll;
  };

  this.clearPosterIfNecessary = () => {
    if (!this.showPoster) delete this.output.args.poster;
  };

  this.clearPlayerVersionIfNecessary = () => {
    if (!this.showPlayerVersion) delete this.output.args.version;
  };

  const checkAndUnselectPodcast = () => {
    if (
      (this.output.embedType === 'audio-podcast' || this.output.embedType === 'video-podcast') &&
      !this.allowPodcastForChannel()
    ) {
      // User had 'Podcast' selected, but that is no longer valid.
      this.output.embedType = 'javascript';
    }
  };

  this.selectAllBroadcasts = () => {
    this.output.channelId = this.account.channel_id;
    this.output.all_m3u8 = this.account.static_playlist_url;
    checkAndUnselectPodcast();
  };

  this.selectCustomChannel = (channel) => {
    this.output.type = 'channel';
    this.output.channel = channel;
    if (!channel) return;
    this.output.channelId = channel.id;

    if (this.m3u8Enabled || this.FeatureFlags.podcast) {
      this.output.channel_m3u8 = '';
      ngResources.channel = this.Channel.get({ id: this.output.channelId }, (c) => {
        if (channel.id != c.id) return; //race condition
        this.output.channel = c;
        this.output.channel_m3u8 = c.static_playlist_url;
        checkAndUnselectPodcast();
      });
    } else {
      checkAndUnselectPodcast();
    }
  };

  this.selectOneSource = (source) => {
    this.output.type = 'source';
    this.output.source = source;
    if (!source) return;
    this.output.sourceId = source.id;
    this.output.channelId = source.channel_id;

    if (this.m3u8Enabled) {
      this.output.source_m3u8 = '';
      if (source.type == 'boxcaster') {
        ngResources.boxcaster = this.BoxCaster.get({ id: this.output.sourceId }, (b) => {
          if (source.id != b.id) return; //race condition
          this.output.source_m3u8 = b.static_playlist_url;
        });
      } else if (source.type == 'static_rtmp') {
        ngResources.staticRTMP = this.StaticRTMP.get({ id: this.output.sourceId }, (s) => {
          if (source.id != s.id) return; //race condition
          this.output.source_m3u8 = s.static_playlist_url;
        });
      }
    }
    checkAndUnselectPodcast();
  };

  this.selectSingleBroadcast = (broadcast) => {
    //console.log('selecting single broadcast', broadcast.id);
    this.output.broadcast = broadcast;
    if (!broadcast) {
      this.output.broadcastId = '';
      this.output.channelId = '';
      this.output.single_m3u8 = '';
      checkAndUnselectPodcast();
      return;
    }
    this.output.broadcastId = broadcast.id;
    this.output.channelId = broadcast.channel_id;

    if (this.m3u8Enabled) {
      this.output.single_m3u8 = '';
      ngResources.broadcast = this.Broadcast.get({ id: this.output.broadcastId }, (b) => {
        if (broadcast.id != b.id) return; //race condition
        this.output.single_m3u8 = b.static_playlist_url;
      });
    }
    checkAndUnselectPodcast();
  };

  this.validateBroadastSelection = (b) => {
    // block ticketed broadcasts from static m3u8
    if (this.output.integrationType == 'm3u8') {
      if (b.is_ticketed) {
        throw new Error('This broadcast is ticketed, which is not supported by static M3U8.');
      }
    }
  };

  this.changeAutoplayOptions = () => {
    if (this.output.args.autoplay === 'try-muted') {
      this._savePlayInline = this.output.args.playInline;
      this.output.args.playInline = true;
      this.disablePlayInline = true;
    } else {
      this.output.args.playInline = this._savePlayInline;
      delete this._savePlayInline;
      delete this.disablePlayInline;
    }
  };

  this.showHideAutoplayOptions = () => {
    if (this.showAutoplayOptions) {
      this._lastAutoplay = this.output.args.autoplay;
      delete this.output.args.autoplay;
      this.showAutoplayOptions = false;
    } else {
      if (this._lastAutoplay) {
        this.output.args.autoplay = this._lastAutoplay;
        delete this._lastAutoplay;
      } else {
        this.output.args.autoplay = 'true';
      }
      this.showAutoplayOptions = true;
    }
    this.changeAutoplayOptions();
  };

  this.loading = () => {
    function check(ngResourceObj) {
      return ngResourceObj && ngResourceObj.$promise && !ngResourceObj.$resolved;
    }
    return (
      check(ngResources.boxcaster) || check(ngResources.broadcast) || check(ngResources.channel)
    );
  };

  this.formatSourceOpt = function (b) {
    if (b.type == 'boxcaster') {
      return `${b.name} (${b.status})`;
    } else {
      return `RTMP: ${b.name}`;
    }
  };

  this.formatBroadcastOpt = function (b) {
    var starts_at = moment(b.starts_at).format('lll');
    return `${b.name} (${starts_at})`;
  };

  this.showPreview = (type) => {
    // NOTE: v3 needs special argument to be previewable on dashboard without
    // intpreting our window.location.hash as part of a redirect
    var args = angular.copy(this.output.args);
    args.disableRedirectRulesOnLoad = true;
    var script;
    if (type == 'highlights') {
      script = EmbedCodeGenerator.v3Highlights(this.output.channelId, args);
    } else {
      script = EmbedCodeGenerator.v3WidgetEmbed(this.output.channelId, args);
    }
    $uibModal.open({
      size: 'lg',
      template: require('./modal-preview.html'),
      controller: function ($scope, $uibModalInstance, $timeout) {
        'ngInject';
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        $timeout(() => iframeify(script));
      },
    });
  };

  this.uploadPoster = (file) => {
    file.upload().then((response) => {
      this.output.args.poster = response.view_url;
    });
  };

  this.uploadCustomPreroll = (file) => {
    file.upload().then((response) => {
      this.output.args.customPreroll = response.view_url;
    });
  };

  this.showSDKs = () => {
    this.output.integrationType = 'sdk';
  };

  this.changeLayout = (layout) => {
    // toggle appropriate advanced settings
    if (layout == 'player-only') {
      this.output.args.showTitleAndDescription = false;
      this.output.args.showDocuments = false;
      this.output.args.showIndex = false;
      this.output.args.showRelated = false;
      this.output.args.showHighlights = false;
      this.output.args.playlistOnRight = false;
      this.output.args.showDonations = false; // always hide donations because it would cause title to appear
      delete this.output.args.showChat;
    } else if (layout == 'player-and-title') {
      this.output.args.showTitleAndDescription = true;
      this.output.args.showDocuments = false;
      this.output.args.showIndex = false;
      this.output.args.showRelated = false;
      this.output.args.showHighlights = false;
      this.output.args.playlistOnRight = false;
      this.output.args.showDonations = !!cs.showDonations; // default to account content settings
      delete this.output.args.showChat;
    } else if (layout == 'player-with-playlist') {
      this.output.args.showTitleAndDescription = true;
      this.output.args.showDocuments = true;
      this.output.args.showIndex = true;
      this.output.args.showRelated = true;
      this.output.args.showHighlights = true;
      this.output.args.playlistOnRight = true;
      this.output.args.showDonations = !!cs.showDonations; // default to account content settings
      if (this.FeatureFlags.viewer_chat) {
        this.output.args.showChat = true;
      }
    }
  };

  this.checkFilterForIntegration = (integrationType) => {
    if (integrationType == 'feeds') {
      // single broadcast filter is not supported
      if (this.output.type == 'single') {
        this.output.type = 'all';
      }
    } else if (integrationType == 'podcast') {
      // the only valid option is a channel filter
      if (this.output.type != 'channel') {
        this.selectCustomChannel(this.channels[0]);
      }
    } else if (integrationType == 'm3u8') {
      // all filter options are supported
    } else if (integrationType == 'app') {
      // all filter options are supported
    }
  };

  this.outputCode = (type) => {
    if (type == 'broadcasts') {
      if (this.output.embedType == 'javascript') {
        return this.output.embedCode3;
      } else if (this.output.embedType == 'iframe') {
        return this.output.iframeCode3;
      } else if (this.output.embedType == 'link') {
        return this.output.linkCode3;
      }
    } else if (type == 'highlights') {
      return this.output.highlightsCode3;
    } else if (type == 'other') {
      if (this.output.integrationType == 'app') {
        return this.output.appCode3;
      } else if (this.output.integrationType == 'm3u8') {
        return this.output.m3u8;
      } else if (this.output.integrationType == 'feeds' && this.output.mediaType == 'rss') {
        return this.output.rss3;
      } else if (this.output.integrationType == 'feeds' && this.output.mediaType == 'audio-mrss') {
        return this.output.audioMRSS3;
      } else if (this.output.integrationType == 'feeds' && this.output.mediaType == 'video-mrss') {
        return this.output.videoMRSS3;
      } else if (
        this.output.integrationType == 'feeds' &&
        this.output.mediaType == 'roku-direct-publisher'
      ) {
        return this.output.rokuDirectPublisher;
      } else if (
        this.output.integrationType == 'podcast' &&
        this.output.mediaType == 'audio-podcast'
      ) {
        return this.output.audioPodcast3;
      } else if (
        this.output.integrationType == 'podcast' &&
        this.output.mediaType == 'video-podcast'
      ) {
        return this.output.videoPodcast3;
      }
    }
  };

  this.copyLabel = (type) => {
    if (type == 'broadcasts') {
      if (this.output.embedType == 'link') {
        return 'Copy this Link to Share';
      } else {
        return 'Copy & Paste into your Website';
      }
    } else if (type == 'highlights') {
      return 'Copy & Paste into your Website';
    } else if (type == 'other') {
      if (this.output.integrationType == 'app') {
        return 'Copy this Web View URL';
      } else if (this.output.integrationType == 'm3u8') {
        return 'Copy this M3U8 URL';
      } else if (this.output.integrationType == 'podcast') {
        return 'Copy this Feed URL';
      } else if (this.output.integrationType == 'feeds') {
        return 'Copy this Feed URL';
      }
    }
  };

  this.showPreviewEmbed = (type) => {
    if (type == 'broadcasts' || type == 'highlights') {
      if (this.output.embedType == 'link') {
        return false;
      }
      return true;
    }
    return false;
  };
}

function iframeify(script) {
  var iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.width = '100%';
  iframe.src = '/404-just-so-i-have-right-protocol-on-window';
  $('#modal-preview-script').html(iframe);
  setTimeout(() => {
    var doc;
    if (iframe.contentDocument) {
      // FF Chrome
      doc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      // IE
      doc = iframe.contentWindow.document;
    }
    doc.open(); //'text/htmlreplace');
    doc.write(
      '<link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" integrity="sha384-1q8mTJOASx8j1Au+a5WDVnPi2lkFfwwEAa8hDDdjZlpLegxhjVME1fgjWPGmkzs7" crossorigin="anonymous">'
    );
    doc.write(script);
    doc.write(
      '<script src="//js.boxcast.com/libs/iframeResizer-3.5.2.contentWindow.min.js"></script>'
    );
    doc.close();
    setTimeout(() => $(iframe).iFrameResize(), 0);
  }, 0);
}



// WEBPACK FOOTER //
// ./app/pages/embed/embed-directive.js